module.exports = __webpack_public_path__ + "static/media/IntC.3f2b25e2.jpg";